import { Button, TextField, Autocomplete } from "@mui/material";
import Popover from "src/generic-ui/Popover";
import { useFormik } from "formik";
import { useState } from "react";
import { logger } from "src/services";
import { IDeliveryman } from "src/types";
import { orderService } from "src/services/order.service";
import ToastNotification, {
  notifyError,
  notifySuccess,
} from "src/generic-ui/ToastNotification";
import { replaceSpecialCharacter } from "src/helpers/utility/convert-string";
import { useDeliverymen } from "src/hooks/deliveryman/useDeliveryman";

export default function ChangeDeliveryman({
  mutate,
  orderId,
  deliverymanId,
}: any) {
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState<boolean>(false);
  const [selectedDeliveryman, setSelectedDeliveryman] = useState<string>("");

  const {
    isLoading,
    deliverymen,
    error,
    meta,
    mutate: userMutate,
  } = useDeliverymen({
    limit: 500,
    page: 1,
  });

  const initialOrderChangeUpdateFormValue: {
    deliveryman: string;
  } = {
    deliveryman: "",
  };

  const { handleBlur, handleChange, values, handleSubmit, submitForm } =
    useFormik({
      initialValues: initialOrderChangeUpdateFormValue,
      onSubmit: async (values, helper) => {
        try {
          const response = await orderService.updateOrder(orderId, values);
          logger.log(response);
          mutate();
          notifySuccess("Order deliveryman updated successfully");
          helper.resetForm();
        } catch (error) {
          logger.error(error);
          notifyError(error.message);
        }
      },
    });

  return (
    <>
      <form action="">
        <Autocomplete
          id="combo-box-demo"
          placeholder="status"
          fullWidth
          value={deliverymen?.find((d) => d.id === values.deliveryman) || null}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          options={deliverymen || []}
          getOptionLabel={(option: IDeliveryman) =>
            option.user?.firstName || ""
          }
          inputValue={inputValue}
          onInputChange={(_, newInputValue) => {
            setInputValue(newInputValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Deliveryman"
              placeholder="Select deliveryman"
            />
          )}
          onChange={(event: any, newValue: IDeliveryman | null) => {
            handleChange("deliveryman")(newValue?.id || "");
            setSelectedDeliveryman(newValue?.id || "");
            setOpen(true);
          }}
          onBlur={handleBlur}
        />
        <Popover
          title=""
          width={400}
          height={200}
          open={open}
          setOpen={setOpen}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="text-center">
            <p className="text-base font-semibold mb-3">Update deliveryman</p>
            <p className="my-2">
              Deliveryman:{" "}
              {
                deliverymen?.find((i) => i.id == values.deliveryman)?.user
                  ?.firstName
              }
            </p>
            <Button
              className="bg-red-500 hover:bg-red-600 text-white"
              onClick={() => setOpen(false)}
            >
              close
            </Button>
            <Button
              className="ml-2 bg-indigo-500 hover:bg-indigo-600 text-white"
              onClick={() => {
                submitForm();
                setOpen(false);
                setSelectedDeliveryman("");
              }}
            >
              submit
            </Button>
          </div>
        </Popover>
      </form>
    </>
  );
}
